var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3333 9.70378L16 16.0001M16 16.0001L4.66663 9.70378M16 16.0001V28.6668M28 21.4115V10.5887C28 10.1319 28 9.90344 27.9327 9.6997C27.8732 9.51946 27.7757 9.35402 27.6472 9.21444C27.5017 9.05665 27.3021 8.94572 26.9027 8.72385L17.036 3.24237C16.6579 3.03229 16.4688 2.92725 16.2687 2.88606C16.0913 2.84962 15.9087 2.84962 15.7315 2.88606C15.5312 2.92725 15.3421 3.03229 14.964 3.24237L5.09729 8.72385C4.69793 8.94572 4.49825 9.05665 4.35284 9.21444C4.22421 9.35402 4.12687 9.51946 4.06731 9.6997C4 9.90344 4 10.1319 4 10.5887V21.4115C4 21.8684 4 22.0968 4.06731 22.3005C4.12687 22.4808 4.22421 22.6463 4.35284 22.7857C4.49825 22.9436 4.69793 23.0545 5.09729 23.2764L14.964 28.7579C15.3421 28.968 15.5312 29.0729 15.7315 29.1141C15.9087 29.1507 16.0913 29.1507 16.2687 29.1141C16.4688 29.0729 16.6579 28.968 17.036 28.7579L26.9027 23.2764C27.3021 23.0545 27.5017 22.9436 27.6472 22.7857C27.7757 22.6463 27.8732 22.4808 27.9327 22.3005C28 22.0968 28 21.8684 28 21.4115Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.2937310f4e7ac4e819ef2bfa04dd4035.svg";
export { ForwardRef as ReactComponent };